import { reactive, computed, onMounted, onUnmounted } from "vue";
import { breakpointMedium, breakpointSmall } from "../tokens.js";
const BREAKPOINTS = {
  desktop: {
    minWidth: breakpointMedium
  },
  tablet: {
    minWidth: breakpointSmall,
    maxWidth: breakpointMedium
  },
  mobile: {
    maxWidth: breakpointSmall
  }
};
function useBreakpoints() {
  const viewportInfo = reactive({
    width: null
  });
  const isDesktop = computed(() => {
    return viewportInfo.width >= BREAKPOINTS.desktop.minWidth;
  });
  const isTablet = computed(() => {
    return viewportInfo.width >= BREAKPOINTS.tablet.minWidth && viewportInfo.width < BREAKPOINTS.tablet.maxWidth;
  });
  const isMobile = computed(() => {
    return viewportInfo.width < BREAKPOINTS.mobile.maxWidth;
  });
  function updateViewportInfo() {
    viewportInfo.width = window.innerWidth;
  }
  function addEventListener() {
    window.addEventListener("resize", updateViewportInfo);
  }
  function removeEventListener() {
    window.removeEventListener("resize", updateViewportInfo);
  }
  onMounted(() => {
    updateViewportInfo();
    addEventListener();
  });
  onUnmounted(removeEventListener);
  return { isDesktop, isTablet, isMobile };
}
export {
  useBreakpoints as u
};
